import React from 'react';
import clsx from 'clsx';
import styles from './Notification.scss';
export function NotificationNest(_ref) {
  let {
    children,
    className,
    contentClassName
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.nest, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.nestContent, contentClassName)
  }, children));
}
//# sourceMappingURL=NotificationNest.js.map